<template>
  <div>
    <SeedJung_Header></SeedJung_Header>
    <div class="baseFrame">
      <div class="pc-content">
        <div class="imgLeft">
          <img src="assets/channy/seedjung_best_7.jpg" alt="" />
        </div>
        <div class="write">
          <h2>체형상담, 컴플렉스 극복</h2>
          <h5>2021년, 바디프로필 붐. 어쩌면 그 이전부터 있어왔던 몸매에 대한 평가와 지적.</h5>
          <p class="description">혼자 고민하며 힘들어 하던 시절이 있었는데, 이제는 상담사가 되어 있네요.<br>내담자들에게 도움이 될 수 있어 감사할 따름입니다.</p>
          <br /><br />
          <p class="description">안녕하세요, 시드정 대표 염성찬 상담사 입니다.</p>
          <br />
          <p class="description"><span style="color: black;">181cm, 57kg</span> 고등학교때 키와 몸무게 입니다. 말랐다는 소리가 제일 듣기 싫었습니다.<br />극복하려고 식단 조절과 운동을 해 보았지만, 쉽게 변화를 이끌어내기 어려웠습니다.</p>
          <br />
          <p class="description">하지만 음식을 과하게 먹어보니 결국 답은 있더군요.<br />저는 살이 골고루 찌지않고 배만 나오는 체형. 선택지가 좁혀지니 생각이 맑아졌습니다.<br /><br />저는 운동을 통해서 극복해야만 했어요.</p>
          <br />
          <p class="description">이후 저는 74kg까지 늘리는데 성공했지만, 힘든일을 겪게 됬습니다.</p>
          <br />
          <p class="description">신호위반 차량에 맨몸으로 치여 몸이 부셔진거죠.<br />재활치료 기간만 3년. 운동은 포기해야만 했습니다.</p>
          <br />
          <p class="description">몸무게는 더 처참했습니다. 3년간 21kg이 빠져서 55kg가 되었으니까요.</p>
          <br />
          <p class="description">재활이후 운동은 혼자 해야만 했습니다. 어깨가 여전히 아파서 운동하는 자세가 남들과 조금 달랐기에<br />정말 많은 지적이 있었어요. 마른분들이 왜 헬스장을 가기 싫어하는지 다시금 깨닫는 순간이었죠.</p>
          <br />
          <p class="description">이후 1년 6개월. 근육량 27kg -> 39kg, 체중 55kg -> 72kg를 만들었고. 바디프로필도 찍게 되었어요.<br /><br />저는 트레이너, 운동선수가 아닙니다. 평범한 직장인 이었어요.<br />컴플렉스를 극복하려고 노력했던 평범한 사람이기에 내담자의 입장에서 도움을 드릴 수 있다고 믿어요.</p>
          <p class="description">힘든 시기를 이겨낼 수 있었던 마인드와 노하우를 여러분들과 공유하고 싶습니다.<br /> 시드정은 경험을 바탕으로, 여러분의 건강과 자신감 회복을 위해 최선을 다해 도와드리겠습니다. </p>
          <br />
          <p class="description">여러분의 꿈과 목표를 향한 여정에 시드정이 함께 하겠습니다. 감사합니다.</p>
        </div>
      </div>

      <div class="mobile-content">
        <div class="imgLeft">
          <img src="assets/channy/seedjung_best_7.jpg" alt="" />
        </div>
        <div class="write">
          <h2>체형상담, 컴플렉스 극복</h2>
          <h5>2021년, 바디프로필 붐. <br />어쩌면 그 이전부터 있어왔던 몸매에 대한 평가와 지적.</h5>
          <p class="description">혼자 고민하며 힘들어 하던 시절이 있었는데, 이제는 상담사가 되어 있네요. 내담자들에게 도움이 될 수 있어 감사할 따름입니다.</p>
          <br /><br />
          <p class="description">안녕하세요, 시드정 대표 염성찬 상담사 입니다.</p>
          <br />
          <p class="description"><span style="color: black;">181cm, 57kg</span> 고등학교때 키와 몸무게 입니다. 말랐다는 소리가 제일 듣기 싫었습니다. 극복하려고 식단 조절과 운동을 해 보았지만, 쉽게 변화를 이끌어내기 어려웠습니다.</p>
          <br />
          <p class="description">하지만 음식을 과하게 먹어보니 결국 답은 있더군요. 저는 살이 골고루 찌지않고 배만 나오는 체형. 선택지가 좁혀지니 생각이 맑아졌습니다. 저는 운동을 통해서 극복해야만 했어요.</p>
          <br />
          <p class="description">이후 저는 74kg까지 늘리는데 성공했지만, 힘든일을 겪게 됬습니다.</p>
          <br />
          <p class="description">신호위반 차량에 맨몸으로 치여 몸이 부셔진거죠. 재활치료 기간만 3년. 운동은 포기해야만 했습니다.</p>
          <br />
          <p class="description">몸무게는 더 처참했습니다. 3년간 21kg이 빠져서 55kg가 되었으니까요.</p>
          <br />
          <p class="description">재활이후 운동은 혼자 해야만 했습니다. 어깨가 여전히 아파서 운동하는 자세가 남들과 조금 달랐기에 정말 많은 지적이 있었어요. 마른분들이 왜 헬스장을 가기 싫어하는지 다시금 깨닫는 순간이었죠.</p>
          <br />
          <p class="description">이후 1년 8개월. 근육량 27kg -> 41kg, 체중 55kg -> 72kg를 만들었고. 바디프로필도 찍게 되었어요. 저는 트레이너, 운동선수가 아닙니다. 평범한 직장인 이었어요. 컴플렉스를 극복하려고 노력했던 평범한 사람이기에 내담자의 입장에서 도움을 드릴 수 있다고 믿어요.</p>
          <p class="description">힘든 시기를 이겨낼 수 있었던 마인드와 노하우를 여러분들과 공유하고 싶습니다. 시드정은 경험을 바탕으로, 여러분의 건강과 자신감 회복을 위해 최선을 다해 도와드리겠습니다.</p>
          <br />
          <p class="description">여러분의 꿈과 목표를 향한 여정에 시드정이 함께 하겠습니다. 감사합니다.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SeedJung_Header from './SeedJung_Header.vue';

export default {
  name: 'SeedJung_Introduction',
  props: {
    msg: String
  },
  components: {
    SeedJung_Header
  }
}
</script>

<style scoped>
.baseFrame {
  padding: 220px 12vw 200px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
}

.pc-content {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
}

.mobile-content {
  display: none;
}

.imgLeft {
  flex: 0 0 auto;
  margin-right: 60px;
}

.imgLeft img {
  max-width: 500px;
  height: auto;
}

.write {
  flex: 1 1 0%;
  padding-left: 40px;
}

h2 {
  font-size: 2.2rem;
  font-weight: bold;
  margin-bottom: 30px;
}

h5 {
  font-size: 1.3rem;
  line-height: 1.6;
  margin-bottom: 30px;
}

.description {
  font-size: 1.2rem;
  line-height: 1.8;
  margin-bottom: 20px;
}

@media (max-width: 767px) {
  .baseFrame {
    padding: 85px 20px 100px; /* 상단 여백 추가 */
    flex-direction: column;
    align-items: center;
  }

  .pc-content {
    display: none;
  }

  .mobile-content {
    display: block;
    width: 100%;
    text-align: center;
  }

  .imgLeft {
    margin-right: 0;
    margin-bottom: 30px;
    text-align: center;
  }

  .imgLeft img {
    max-width: 350px;
    width: 100%;
    height: auto;
  }

  .write {
    text-align: left;
    padding-left: 0;
  }

  h2 {
    font-size: 2.2rem;
    margin-bottom: 20px;
  }

  h5 {
    font-size: 1.5rem;
    margin-bottom: 20px;
  }

  .description {
    font-size: 1.5rem;
    line-height: 1.6;
    margin-bottom: 15px;
  }
}
</style>